import React from "react";
import {Button, Tooltip} from "@mui/material";
import {useTheme} from "../../../contexts/theme";
import {commonButtonStyles} from "../../../utils/commonButtonStyles";

interface TransparentButtonProps{
    text: string;
    disabled?: boolean;
    onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
    width?: string;
    onFocus?: () => void;
    onBlur?: () => void;
    height?: string;
    marginLeft?: string;
    marginRight?: string;
    icon?: any;
    startIcon?: React.ReactNode;
    type?: 'button' | 'submit' | 'reset';
    color?: string;
    selected?: boolean;
    login?: boolean;
    tooltipText?: string;
    showTooltip?: boolean;
    needBackground?: boolean;
    onKeyDown?: (e: React.KeyboardEvent<any>) => void;
}

const TransparentButton: React.FC<TransparentButtonProps> = ({onKeyDown = () => {}, needBackground, login = false, type, startIcon, height, icon, color = 'white', marginLeft, onBlur, width, text, disabled, onClick, onFocus, selected, marginRight, tooltipText, showTooltip}) => {

    const theme = useTheme();

    const buttonElement = (
        <Button
            onBlur={onBlur}
            type={type}
            onFocus={onFocus}
            variant='outlined'
            disabled={disabled}
            onClick={onClick}
            startIcon={startIcon}
            onKeyDown={onKeyDown}
                sx={{
                    marginLeft: marginLeft || undefined,
                    marginRight: marginRight || undefined,
                    height: height || "40px",
                    width: width || 'auto',
                    ...commonButtonStyles(theme, { selected, login, color, needBackgroundColor: needBackground }),
                }}
        >
            {text}
        </Button>
    )

    return (
        showTooltip ? (
            <Tooltip title={tooltipText}>
                <span>{buttonElement}</span>
            </Tooltip>
        ) : (
            buttonElement
        )
    );
};

export default TransparentButton;